import { isFunction } from 'lodash'
import IframeResizer from '@icij/murmur/lib/utils/iframe-resizer'


export default function ({ router, config, i18n }) {
  const iframeResizer = IframeResizer.create()

  function legacyRouterMode ({ fullPath }, from, next) {
    if (fullPath.substr(0, 2) === '/#') {
      const path = fullPath.substr(2)
      next(path)
      return
    }
    next()
  }

  function skipHome(to, from, next) {
    if (to.name === 'home') {
      const locale = i18n.locale
      return next({ name: 'list', params: { locale } })
    }
    return next()
  }

  function setDefaultLocale(to, from, next) {
    if (!to.params.locale) {
      const locale = i18n.locale
      const name = to.name
      return next({ name, params: { ...to.params, locale }, query: to.query, replace: true })
    }
    return next()
  }

  async function setPageTitleFromMeta ({ meta }, from, next) {
    const params = { router, config }
    const title = isFunction(meta.title) ? await meta.title(params) : meta.title
    document.querySelector('title').innerText = title || config.get('project.name')
    document.title = title || config.get('project.name')
    next()
  }

  async function scrollToTop (to, from, next) {    
    if (to.name === 'player.profile' && from.name) {
      if (IframeResizer.isEmbedded()) {
        const pymChild = await iframeResizer.initializer
        pymChild.scrollParentToChildPos(0)
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
    }
    next()
  }

  function sendHeightToPym() {
    iframeResizer.sendHeight()
  }

  router.beforeEach(legacyRouterMode)
  router.beforeEach(skipHome)
  router.beforeEach(setDefaultLocale)
  router.beforeEach(setPageTitleFromMeta)
  router.beforeEach(scrollToTop)
  router.afterEach(sendHeightToPym)

  return router
}
